<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<!-- <app-search-component></app-search-component> -->
<div class="container">
  <div class="card-body patient-name-form">
    <h5 class="card-title text-left">Lookup record</h5>
    <div class="input-group">
      <input id="myInput" (keyup)="myFunction()" placeholder="Enter Patient Name or DOB">
    </div>
  </div>
</div>

<div class="container">
  <h5 class="card-title text-left ">My Checked in Patients</h5>


  <table id="myTable" class="table table-hover border-left-0 border-right-0 table-bordered">

    <tr class="header">
      <th>Time</th>
      <th>Checkin-Id</th>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Date of Birth</th>
      <th>Gender</th>
      <th>Action</th>
    </tr>


    <tbody *ngFor="let cp of chkdet">

      <tr>
        <td>{{ cp.chktime | date:'h:mm a':'+0530' }}</td>
        <td>{{cp.cid}}</td>
        <td>{{cp.first_name}}</td>
        <td>{{cp.last_name}}</td>
        <td>{{cp.dob| date:'dd-MM-yyyy'}}</td>
        <td>{{cp.gender}}</td>
        <td><button type="button" class="btn btn-success table-btn" [routerLink]="['/phydash/'+cp.pid]"
            [queryParams]="{cid: cp.cid}">Details</button>
        </td>
      </tr>
    </tbody>
  </table>

</div>

<div *ngIf="undefined !==chkdet && chkdet.length < 1" #noRecord>
  <p align="center">
    <strong>No record found</strong>
  </p>
</div>